import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=e3358be6&scoped=true&"
import script from "./performance.vue?vue&type=script&lang=ts&"
export * from "./performance.vue?vue&type=script&lang=ts&"
import style0 from "./performance.vue?vue&type=style&index=0&id=e3358be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3358be6",
  null
  
)

export default component.exports